import { apiClient } from '@shared/services/http/http.service.js'

const NOTIFICATIONS_PATH = 'notifications'

export const NOTIFICATIONS_PAGE_SIZE = 20

export async function fetchUnreadCount() {
  const { data } = await apiClient('core').get(`${NOTIFICATIONS_PATH}/unread-count`)
  return data
}

export async function fetchPreview() {
  const { data } = await apiClient('core').get(`${NOTIFICATIONS_PATH}/preview`)
  return data
}

export async function fetchNotifications({ page = 1, read, from, to } = {}) {
  const parameters = {
    paginate: true,
    limit: NOTIFICATIONS_PAGE_SIZE,
    page,
    sort: 'scheduledAt:desc',
    ...(read !== undefined && { read }),
    ...(from && { createdAtFrom: from }),
    ...(to && { createdAtTo: to }),
  }

  const { data } = await apiClient('core').get(`${NOTIFICATIONS_PATH}/reminders`, { params: parameters })
  return data
}

export async function fetchNotification(id) {
  const { data } = await apiClient('core').get(`${NOTIFICATIONS_PATH}/reminders/${id}`)
  return data
}

export async function markNotificationAsRead(id) {
  const { data } = await apiClient('core').patch(`${NOTIFICATIONS_PATH}/reminders/${id}/read`)
  return data
}

export async function markAllNotificationsAsRead() {
  const { data } = await apiClient('core').patch(`${NOTIFICATIONS_PATH}/read-all`)
  return data
}

export async function createNotification(payload) {
  const { data } = await apiClient('core').post(`${NOTIFICATIONS_PATH}/reminders`, payload)
  return data
}

export async function createBulkNotifications(items) {
  const { data } = await apiClient('core').post(`${NOTIFICATIONS_PATH}/bulk`, items)
  return data
}

export async function fetchTenants() {
  const { data } = await apiClient('core').get('tenant/tenants')
  return data
}

export async function fetchCompanies() {
  const { data } = await apiClient('core').get('master-data/companies')
  return data
}
